export const SET_HRES88E_INDEX_DISP = 'SET_HRES88E_INDEX_DISP'
export const GET_HRES88E_INDEX_DISP = 'GET_HRES88E_INDEX_DISP'
export const SET_HRES88E_DETAIL_DISP = 'SET_HRES88E_DETAIL_DISP'
export const GET_HRES88E_DETAIL_DISP = 'GET_HRES88E_DETAIL_DISP'
export const TOGGLE_HRES88E_PAGE = 'TOGGLE_HRES88E_PAGE'
export const SET_HRES88E_COLUMNS = 'SET_HRES88E_COLUMNS'
export const GET_HRES88E_COLUMNS = 'GET_HRES88E_COLUMNS'
export const SET_HRES88E_LABELS = 'SET_HRES88E_LABELS'
export const GET_HRES88E_LABELS = 'GET_HRES88E_LABELS'
export const RECEIVED_HRES88E_COLUMNS_LABELS = 'RECEIVED_HRES88E_COLUMNS_LABELS'
export const SET_HRES88E_INDEX = 'SET_HRES88E_INDEX'
export const GET_HRES88E_INDEX = 'GET_HRES88E_INDEX'
export const SET_HRES88E_INDEX_SELECTED = 'SET_HRES88E_INDEX_SELECTED'
export const GET_HRES88E_INDEX_SELECTED = 'GET_HRES88E_INDEX_SELECTED'
export const RECEIVED_HRES88E_INDEX = 'RECEIVED_HRES88E_INDEX'
export const POST_HRES88E_DETAIL_SAVE = 'POST_HRES88E_DETAIL_SAVE'
export const SET_HRES88E_DETAIL = 'SET_HRES88E_DETAIL'
export const GET_HRES88E_DETAIL = 'GET_HRES88E_DETAIL'
export const RECEIVED_HRES88E_DETAIL = 'RECEIVED_HRES88E_DETAIL'
export const GET_HRES88E_DROPDOWNS = 'GET_HRES88E_DROPDOWNS'
export const SET_HRES88E_DROPDOWNS = 'SET_HRES88E_DROPDOWNS'
export const RECEIVED_HRES88E_DROPDOWNS = 'RECEIVED_HRES88E_DROPDOWNS'
export const RECEIVED_HRES88E_CREATE = 'RECEIVED_HRES88E_CREATE'
export const GET_HRES88E_LOGICAL_LISTFIELDS = 'GET_HRES88E_LOGICAL_LISTFIELDS'
export const SET_HRES88E_LOGICAL_LISTFIELDS = 'SET_HRES88E_LOGICAL_LISTFIELDS'
export const RECEIVED_HRES88E_LOGICAL_LISTFIELDS = 'RECEIVED_HRES88E_LOGICAL_LISTFIELDS'
export const GET_HRES88E_DETAIL_CODJOB = 'GET_HRES88E_DETAIL_CODJOB'
export const SET_HRES88E_DETAIL_CODJOB = 'SET_HRES88E_DETAIL_CODJOB'
export const RECEIVED_HRES88E_DETAIL_CODJOB = 'RECEIVED_HRES88E_DETAIL_CODJOB'
export const POST_HRES88E_CANCEL = 'POST_HRES88E_CANCEL'



// WEBPACK FOOTER //
// ./src/store/modules/hres88e/mutation-types.js